module.exports = __webpack_public_path__ + "img/pbi2.326a2f9d.png";